<template>
    <div>
      <h2>Calculating Maximum Discount...</h2>
      <button @click="proceed">Continue</button>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      proceed() {
        this.$emit('calculateMaxDiscount'); // Trigger calculation
        this.$emit('nextStep'); // Move to next step
      }
    }
  };
  </script>
  
  <style scoped>
  h2 {
    margin: 20px 0;
    color: #333;
  }
  </style>
  